import { PureComponent } from 'react'
import styled from 'glamorous'
import { $ } from 'utils'

import { Icon } from 'components'

const CheckboxContainer = styled.div({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  userSelect: 'none'
}, ({ disabled }) => disabled && ({
  cursor: 'default'
}), 'checkbox')

const IconContainer = styled.div({
  position: 'relative',
  display: 'flex',
  alignSelf: 'flex-start',
  width: 18,
  height: 18,
  backgroundColor: 'transparent',
  border: 'var(--border)',
  borderRadius: 2,
}, ({ type, checked = false, disabled = false }) => {
  const base = {}
  const checkedStyles = checked ? {
    borderColor: 'var(--green)',
    backgroundColor: 'var(--green)'
  } : {}
  if (type === 'violet') {
    base.borderColor = 'var(--violet)'
    if (checked) {
      checkedStyles.borderColor = 'var(--violet)'
      checkedStyles.backgroundColor = 'var(--violet)'
    }
  }
  const disabledStyles = disabled ? {
    borderColor: 'var(--lightestGrey)',
    backgroundColor: 'var(--lightestGrey)',
    cursor: 'default'
  } : {}
  return [base, checkedStyles, disabledStyles]
})

class Checkbox extends PureComponent {

  render() {
    const { selected, disabled, type, onChange, label } = this.props
    return (
      $(CheckboxContainer, { onClick: () => !disabled && onChange(!selected), disabled  },
        $(IconContainer, {
            type,
            checked: selected,
            disabled,
          },
          $(Icon, {
            type: 'checkOn',
            color: 'transparent',
            colorActive: 'var(--white)',
            size: 16,
            viewBox: '8.5 7 16 16',
            isHoverable: false,
            isActive: selected,
          })
        ),
        label
      )
    )
  }
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Checkbox.js